<template>
  <button
    :class="{
      'tab-button': true,
      'tab-button_active': active,
      'tab-button_disabled': !checked
    }"
    @click.self="$emit('clickTab')"
    :disabled="!checked"
  >
    {{ text }}
    <label
      :class="{
        'pi': true,
        'pi-check-square': checked,
        'pi-stop': !checked
      }"
    >
      <input
        class="tab-button__checkbox"
        type="checkbox"
        :checked="checked"
        @change="$emit('changeInput')"
      >
    </label>
  </button>
</template>

<script>

export default {
  name: 'BaseTabButton',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-button {
  padding: 10px 16px;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.4px;
  color: #000000;
  background-color: #FFFFFF;
  border-radius: 4px;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.30);

  &_active {
    color: #FFFFFF;
    background-color: #0080B1;
  }

  &_disabled {
    color: #000000;
    background: #DCDCDC;
  }

  &__checkbox {
    display: none;
  }
}

</style>
